<template>
	<div style='background:white;' class='' v-loading='loading'>

		<tyc :tqobj='tqobj'></tyc>

		<pushdia :pObj='pObj'></pushdia>

		<div class='gPageBorder' id='pdthead'>
			<div class='pdthdfr'>
				<el-row>
					<el-col :span='12'>
						<div class='gwordels' style="width:100%;height:44px;font-size:24px;">
							{{info.taskName}}
						</div>
					</el-col>
					<el-col :span='12' style='text-align: right;'>
						<label style=''>{{$t('app_tscrtime')}}：<label>{{info.taskTime}}</label></label>
					</el-col>
				</el-row>
			</div>
			<div class='pdthdfr taskrow' v-for='item in info.subTask'>
				<el-row style='width:100%;height:100%;'>
					<el-col :span='3' style='height:100%;'>
						<div class='pdts1'>
							{{$t('app_subtask')}}{{item.num}}
						</div>
					</el-col>
					<el-col :span='17' style='height:100%;'>
						<el-row :class="item.taskType == 9? 'pdts2 dtcmgp' : 'pdts2'">
							<nobr>
								<div>
									<label>{{$t('app_taskType')}}：</label>{{item.taskType == '9'? $t('app_dvcomm') : $t('app_pushfile')}}
								</div><!--
              -->
								<div style="width:70%;" v-if="item.taskType == '9'">
									<label>{{$t('app_commtype')}}：</label>
									{{comm[item.content]}}
									<span v-show="item.content == 'XZYY' || item.content == 'ZQ'">
										<label
											style="display:inline-block;margin-left:11%;">{{$t('app_filename')}}：</label>
										{{item.fileName}}
									</span>
								</div><!--
              -->
								<div v-else><label>{{$t('app_filename')}}：</label>{{item.fileName}}</div><!--
              -->
								<div v-if="item.taskType != '9'"><label>{{$t('app_version')}}：</label>{{item.version}}
								</div><!--
              -->
								<div v-if="item.taskType != '9'">
									<label>{{$t('app_distributor')}}：</label>{{item.mechName}}
								</div>
							</nobr>
						</el-row>
					</el-col>
					<el-col :span='4' class='pdts3'>

						<el-popover placement="top" width="120" trigger="hover">
							<el-button slot='reference' type='text' v-show='item.pop'
								style='position:absolute;top:12px;left: 20px;'><i class="fa fa-file-text-o"
									style=""></i></el-button>
							<div v-for='sitem in item.pop'>{{sitem}}</div>
						</el-popover>

						<el-tooltip class="item" effect="dark" :content="barTTip(item.complete,item.total)"
							placement="top">
							<div :style="barColor(item.complete,item.total)"></div>
						</el-tooltip>
						<label>{{$t('app_taskpros')}}：</label>{{item.complete}}/{{item.total}}

					</el-col>
				</el-row>
			</div>
		</div>

		<div class='gPageBorder gTopMg' v-show="true" style=''>

			<el-row>
				<el-col style="height:100px;" :span="24">
					<table style="width:100%;height:100%;border-bottom:1px solid rgba(223,230,236,1);">
						<tr>

							<td v-for="item,index in items"
								style="vertical-align: middle;text-align: center;width:16.666%;background:none;height:100%;cursor:pointer;"
								@click='clickTd(index)'>

								<!-- <div v-if='index == 0'  style="width:0px;height:60px;position:absolute;"></div>
                <div v-else style="min-width:1px;height:60px;background:rgb(223,230,236);position:absolute;float:left;"></div> -->
								<div v-if='index != 0'
									style="min-width:1px;height:calc(80% - 20px);background:rgb(223,230,236);position:absolute;float:left;">
								</div>
								<div v-else
									style="min-width:1px;height:calc(80% - 0px);background:none;position:absolute;float:left;">
								</div>

								<label style="color:rgb(72,87,106);font-size:20px;">{{item.num}}</label>
								<br /><br /><br />
								<label style="color: #99A9BF;">{{item.lb}}</label>

							</td>

						</tr>
					</table>
				</el-col>

			</el-row>

			<el-row>
				<el-col :span='16'>
					<div class='gSgLeftBtn'>
						<el-button v-show="true" :disabled="multipleSelection.length == 0" @click="bcDel" type=''
							class=''>{{$t('app_mulDel')}}</el-button>

						<el-button @click="addPush" type='primary' class=''>{{$t('terminal.list.add_btn')}}</el-button>

						<!-- <el-button  v-show="true"  @click="addTer" type='primary'  class=''>{{$t('app_fileImport')}}</el-button> -->
						<el-button @click="clearn" type='text' class=''>{{$t('app_clear')}}</el-button>

						<el-button v-show='info.taskType != 12' @click="repushFail" type='text'
							class=''>{{$t('app_repushdv')}}</el-button>

						<el-button @click="exportRc" type='text' class=''>{{$t('app_outputdv')}}</el-button>

						<el-button @click="refreshPList" type='text' class=''>{{$t('lin_global.shuaxin')}}</el-button>
					</div>

				</el-col>


				<el-col :offset='0' :span="4">
					<div class='gCtrl'>
						<el-select v-model="bindVl" clearable :placeholder="$t('app_type')" @change='selectChange'>
							<el-option v-for="item in bindSts" :key="item.vl" :label="item.lb" :value="item.vl">
							</el-option>
						</el-select>
					</div>
				</el-col>

				<!-- <el-col :span="4">
            <div class='gCtrl'>

              <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
            </div>
        </el-col> -->


				<el-col :span="4">
					<div class='gSideCtrl'>
						<el-input :placeholder="$t('app_name') + ' & ' + $t('app_number')" v-model='queryKey'
							@keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
					</div>
				</el-col>
			</el-row>



			<el-table class='gTopMg' ref="multipleTable" @row-click='cellClick' :data="tableData" border
				@sort-change='sortChange' @selection-change="handleSelectionChange" style="width: 100%">
				<el-table-column align=center type="selection" width="55">
				</el-table-column>


				<el-table-column header-align='center' align='center' prop="terminalName" sortable='custom'
					:label="$t('app_deviceName')" width="">
					<template slot-scope='scope'>
						<label style='color:#409EFF;cursor:pointer'>{{scope.row.terminalName}}</label>
						<!-- <label style=''>{{scope.row.terminalName}}</label> -->
					</template>
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="terminalNo" sortable='custom'
					:label="$t('app_deviceNo')" width="">
					<template slot-scope='scope'>
						<label style='color:#409EFF;cursor:pointer'>{{scope.row.terminalNo}}</label>
						<!-- <label style=''>{{scope.row.terminalNo}}</label> -->
					</template>
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="terminalModel"
					:label="$t('lin_global.label_model')" width="">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="merchantName" :label="$t('app_distributor')"
					width="">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="terminalNo" :label="$t('app_cursubts')"
					width="">
					<template slot-scope='scope'>
						<label style=''>{{$t('app_subtask') + scope.row.taskNum}}</label>
					</template>
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="progress" :label="$t('app_process')"
					width="">
					<template slot-scope='scope'>
						<label>{{scope.row.data ? scope.row.data.result.progress : scope.row.progress}} %</label>
					</template>
				</el-table-column>

				<el-table-column header-align='center' align='center' :label="$t('app_status')" width="">
					<template slot-scope='scope'>
						<!-- <label>{{getBindSt[scope.row.taskStatus]}}</label> -->
						<label
							v-show="scope.row.taskStatus == 3 || scope.row.taskStatus == 5 || scope.row.taskStatus == -3 "
							style='color:green;cursor:pointer'>{{statusNames[scope.row.taskStatus]}}</label>
						<label v-show="scope.row.taskStatus == 0 "
							style='color:orange;cursor:pointer'>{{statusNames[scope.row.taskStatus]}}</label>
						<label
							v-show="scope.row.taskStatus == -1 || scope.row.taskStatus == -5 || scope.row.taskStatus == -10 || scope.row.taskStatus == -7 "
							style='color:red;cursor:pointer'>{{statusNames[scope.row.taskStatus]}}</label>
						<label
							v-show="scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5  && scope.row.taskStatus != -10 && scope.row.taskStatus != 5 && scope.row.taskStatus != -3 && scope.row.taskStatus != -7"
							style='color:gray;cursor:pointer'>{{statusNames[scope.row.taskStatus]}}</label>
					</template>
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="updateTime" sortable='custom'
					:label="$t('app_pushTime')" width="">
					<template slot-scope='scope'>
						<label>{{scope.row.updateTime}}</label>
					</template>
				</el-table-column>

				<el-table-column header-align='center' align=center prop="cancelNums" :label="$t('app_operate')"
					width="116">
					<template slot-scope='scope'>

						<el-tooltip class="item" effect="dark" :content="$t('app_pause')" placement="top">
							<el-button type='text' v-show='showBtn(3, scope.row.taskStatus)'
								@click='downOperate(2, scope.row)'><i class="fa fa-pause" style=""></i></el-button>
						</el-tooltip>

						<el-tooltip class="item" effect="dark" :content="$t('app_continue')" placement="top">
							<el-button type='text' v-show='showBtn(4, scope.row.taskStatus)'
								@click='downOperate(1, scope.row)'><i class="fa fa-play" style=""></i></el-button>
						</el-tooltip>

						<el-tooltip class="item" effect="dark" :content="$t('app_ccdown')" placement="top">
							<el-button type='text' v-show='showBtn(0, scope.row.taskStatus)'
								@click='cancelCf(scope.row)'><i class="fa fa-window-close" style=""></i></el-button>
						</el-tooltip>


						<el-tooltip class="item" effect="dark" :content="$t('lin_global.chongtui')" placement="top">
							<el-button type='text' v-show='showBtn(1, scope.row.taskStatus)'
								@click='repush(scope.row)'><i class="fa fa-repeat" style=""></i></el-button>
						</el-tooltip>


						<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
							<el-button type='text' v-show='showBtn(2, scope.row.taskStatus)'
								@click='delRow(scope.row)'><i class="fa fa-trash-o"
									style="color:#FF4949"></i></el-button>
						</el-tooltip>

					</template>
				</el-table-column>
			</el-table>

			<div class="gPgDiv" style='gPgDiv'>

				<el-pagination class='gPg' @current-change="pageChange" @size-change="pageSize" :current-page="page"
					:page-sizes='$gRows' :page-size="$gRow" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>

			</div>
		</div>


	</div>
</template>

<style>
	.dtcmgp {
		width: 100%;
		overflow: visible;
	}

	.dtcmgp label {
		display: inline-block;
		overflow: visible;
		text-overflow: initial;
	}

	#pdthead {
		padding: 0 24px 0px 24px;
	}

	.pdthdfr {
		height: 50px;
	}

	.pdthdfr:nth-child(1) {
		line-height: 50px;
		margin-top: 11px;
		margin-bottom: 11px;
	}

	.pdthdfr:nth-child(1) label {
		/* font-size:24px; */
		color: #48576A;
	}

	.taskrow {
		border: 1px solid rgb(213, 228, 254);
		height: 60px;
		margin-bottom: 20px;
		border-radius: 5px;
		overflow: hidden;
		font-size: 13px;
	}

	.pdts1 {
		border-right: 1px solid rgb(232, 236, 241);
		height: 80%;
		position: relative;
		top: 10%;
		line-height: 48px;
		text-align: right;
		color: #409EFF;
		padding-right: 10px;
		margin-right: 10px;
		width: calc(100% - 20px);
		font-size: 17px;
	}

	.pdts2 {
		width: 100%;
		height: 100%;
		line-height: 60px;
		overflow: hidden;
	}

	.pdts2 label {
		color: #99A9BF;
	}

	.pdts2 div {
		display: inline-block;
		float: left;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.pdts2 div:nth-child(1) {
		width: 24%;
	}

	.pdts2 div:nth-child(2) {
		width: 34%;
	}

	.pdts2 div:nth-child(3) {
		width: 21%;
		position: relative;
		overflow: none;
	}

	.pdts2 div:nth-child(4) {
		width: 21%;
	}

	.pdts3 {
		height: 100%;
		line-height: 60px;
		text-align: right;
		padding-right: 24px;
		position: relative;
		overflow: hidden;
	}

	.pdts3 label {
		color: #99A9BF;
	}


	.ptmt td {
		width: 25%;
	}

	.dt-word-main {
		color: rgb(72, 87, 106)
	}

	.dt-word-title {
		color: #99A9BF;
	}

	pre {
		white-space: pre-wrap;
		word-wrap: break-word;
		white-space: -moz-pre-wrap;
		white-space: -pre-wrap;
		white-space: -o-pre-wrap;
		word-break: break-all;
	}

	.dt-launch {
		width: 100%;
		height: 100%;
		background: none;
	}


	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.capture {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		display: inline-block;
	}

	.capture div {
		float: left;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.sm-avatar-uploader-icon {
		font-size: 36px;
		color: #8c939d;
		width: 72px;
		height: 72px;
		line-height: 72px;
		text-align: center;
	}

	.sm-avatar {
		width: 64px;
		height: 64px;
		display: block;
	}
</style>

<script>
	import mm from 'moment'
	import df from '../../../assets/df.png'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import tyc from '@/components/global/tyc'
	import pushdia from './pushdia.vue'
	export default {
		data() {
			var _this = this
			return {
				orderType: '',
				orderName: '',
				tty: '',
				comm: '',
				duration: 6,
				pObj: '',
				tid: '',
				tqobj: '',
				queryKey: '',
				tbOrder: '',
				statusNames: { // add by sing, 2017-06-17
					'-1': this.$t('app_downFail'),
					'-2': this.$t('app_md5Fail'),
					'-3': this.$t('app_theNewgVer'),
					'-4': this.$t('app_fileFmIllegal'),
					'-5': this.$t('app_updateFail'),
					'-6': this.$t('app_usrCancelUpdate'),
					'0': this.$t('app_pushFail'),
					'1': this.$t('app_downloading'),
					'2': this.$t('app_downFinish'),
					'3': this.$t('app_success'), // app_updateSuccess
					'4': this.$t('app_waiting'),
					'5': this.$t('app_success'),
					'6': this.$t('app_pause'),
					'7': this.$t('app_ccdown'),
					'-7': this.$t('app_verror'),
					'-8': this.$t('app_insfail'),
					'-9': this.$t('app_checksignfail'),
					'-10': this.$t('app_uninsfail'),
					'12': this.$t('app_appuninstall')
				},
				taskType: '',
				status: [{
						vl: '-1',
						name: this.$t('app_downFail')
					},
					{
						vl: '-2',
						name: this.$t('app_md5Fail')
					},
					{
						vl: '-3',
						name: this.$t('app_newgVer')
					},
					{
						vl: '-4',
						name: this.$t('app_fileFmIllegal')
					},
					{
						vl: '-5',
						name: this.$t('app_updateFail')
					},
					{
						vl: '-6',
						name: this.$t('app_usrCancelUpdate')
					},
					{
						vl: '0',
						name: this.$t('app_pushFail')
					},
					{
						vl: '1',
						name: this.$t('app_downloading')
					},
					{
						vl: '2',
						name: this.$t('app_downFinish')
					},
					{
						vl: '3',
						name: this.$t('app_success')
					},
					{
						vl: '4',
						name: this.$t('app_waiting')
					},
					{
						vl: '5',
						name: this.$t('app_success')
					},
					{
						vl: '6',
						name: this.$t('app_pause')
					},
					{
						vl: '7',
						name: this.$t('app_ccdown')
					},
					{
						vl: '-7',
						name: this.$t('app_verror')
					},
					{
						vl: '-8',
						name: this.$t('app_insfail')
					},
					{
						vl: '-9',
						name: this.$t('app_checksignfail')
					},
					{
						vl: '-10',
						name: this.$t('app_uninsfail')
					},

				],
				pInfo: [], // 进度处理
				getftype: '',
				getstype: '',
				items: [{
						lb: this.$t('app_total'),
						num: '-'
					},
					{
						lb: this.$t('app_success'),
						num: '-'
					},
					{
						lb: this.$t('app_wait'),
						num: '-'
					},
					{
						lb: this.$t('app_downloading'),
						num: '-'
					},
					{
						lb: this.$t('app_fail'),
						num: '-'
					},
					{
						lb: this.$t('app_cancel'),
						num: '-'
					}
				],
				mechanismData: {
					callback(value) {
						_this.mech = value
						// that.selectChange(value)
						_this.getList()
					}
				},
				mechanismData1: {
					callback(value) {
						_this.mech1 = value
						// that.selectChange(value)
						_this.getDevices()
					}
				},
				mech: '',
				mech1: '',
				srchValue: '',
				multipleSelection: [],
				info: '',
				mapType: {
					'0': this.$t('app_bdmap'),
					'1': 'Google' + this.$t('app_map')
				},
				ctrlType: {
					'0': this.$t('app_off1'),
					'1': this.$t('app_on1'),
				},
				bindSt: {
					'0': this.$t('app_waitupdate'),
					'1': this.$t('app_updateSuccess'),
					'2': this.$t('app_updateFail')
				},
				bindSts: [{
						vl: '',
						lb: this.$t('app_allstatus')
					},
					{
						vl: '1',
						lb: this.$t('app_success')
					},
					{
						vl: '2',
						lb: this.$t('app_waiting')
					},
					{
						vl: '3',
						lb: this.$t('app_downloading')
					},
					{
						vl: '4',
						lb: this.$t('lin_global.concel_tips')
					},
					{
						vl: '5',
						lb: this.$t('app_fail')
					}
				],
				// getBindSt: {
				//   '': this.$t('app_allstatus'),
				//   '1': this.$t('app_success'),
				//   '2': this.$t('app_waiting'),
				//   '3': this.$t('app_downloading'),
				//   '4': this.$t('lin_global.concel_tips'),
				//   '5': this.$t('app_fail')
				// },
				bindVl: '',
				config: '',
				captures: [],
				loading: 0,
				tableData: [],
				tags: [],
				page: 1,
				index: 1,
				hiss: [],
				total: 0
			}
		},
		components: {
			MechanismSelector,
			pushdia,
			tyc
		},
		computed: {

			showUploadNew() {
				//console.log('ccc', this.config.data)
				if (this.config) {
					if (this.config.isoperate == 0) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			}
		},
		methods: {
			barTTip(cp, total) {
				var words = this.$t('app_done')
				if (cp == 0) {
					words = this.$t('app_waiting')
				} else if (total > cp) {
					words = this.$t('app_ing')
				}

				return words
			},
			barColor(cp, total) {
				var color = 'background: rgb(87,205,123);'
				if (cp == 0) {
					color = 'background: yellow;'
				} else if (total > cp) {
					color = 'background: blue;'
				}
				var st = "position:absolute;width:6px;height:100%;right:0;"

				return st + color
			},
			// cycQuery () {
			//   if (this.$route.path == '/task/ptask/detail') {

			//     this.getDetail()
			//     var _this = this
			//     window.dTm = setTimeout(function () {
			//       _this.cycQuery()
			//     }, this.duration * 1000)

			//   } else {
			//     return
			//   }
			// },
			refreshPList() {
				this.getList()
			},
			cancelCf(row) {
				this.$showConfirm('', this.$t('app_iscltask') + '?', this.$t('app_sure'), this.$t('app_cancel'),
					'warnning', () => {
						this.downOperate(3, row)
					})
			},
			repush(row) {
				//console.log(row)
				this.$pushRepush(row.detailId, (res) => {
					// this.delDeviceNo = 0
					this.loading = 0
					if (res.status == 200) {
						this.$message.success(res.message)
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = 0
					// error
				})

			},
			cellClick(row, ev, col) {
				if (col.label && col.label == this.$t('app_operate')) {
					return
				}

				if (col.label == this.$t('app_deviceName') || col.label == this.$t('app_deviceNo')) {

					if (this.tty == 6) {
						this.$setWObj('ndObj', {
							data: row.terminalId
						})
						this.$router.push({
							path: '/non-it-eq/device/detail'
						})
					} else {
						this.$router.push({
							path: '/terList/' + row.terminalId + '/details'
						})
					}

				}

			},
			sortChange(a) {
				switch (a.prop) {
					case 'terminalName':
						this.orderName = '1'
						break
					case 'terminalNo':
						this.orderName = '2'
						break
					case 'updateTime':
						this.orderName = '3'
						break
				}
				this.orderType = a.order == 'descending' ? 'desc' : 'asc'
				this.getList()
			},
			downOperate(vl, row) {

				this.loading = 1
				this.$pushFileDownCtrl(row.detailId, vl + '', row.terminalNo, (res) => {
					this.loading = 0
					if (res.status == 200) {
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = 0
					// error
				})
			},
			clickTd(index) {
				switch (index) {
					case 0:
						this.bindVl = ''
						break
					case 1:
						this.bindVl = '1'
						break
					case 2:
						this.bindVl = '2'
						break
					case 3:
						this.bindVl = '3'
						break
					case 4:
						this.bindVl = '5'
						break
					case 5:
						this.bindVl = '4'
						break
				}
				this.getList()
			},
			exportRc() {
				var terminalName = ''
				var orderType = ''
				var status = ''
				window.open(this.$pTaskExport(this.$route.query.tid, terminalName, orderType, status))
			},
			clearn() {
				var tNameVl = this.queryKey ? this.queryKey : ''
				var statusVl = this.bindVl ? this.bindVl : ''
				this.$showConfirm(
					this.$t("app_tip"),
					this.$t("app_clearTask"),
					this.$t("app_sure"),
					this.$t("app_cancel"),
					"warning",
					() => {
						this.$delTaskDevice({
								terminalName: tNameVl,
								status: statusVl,
								taskId:this.$route.query.tid
							},
							res => {
								if (res.status === 200) {
									this.getList();
								} else {
									this.$message(res.message);
								}
							},
							""
						);
					},
					""
				);
			},
			repushFail() {

				this.loading = 1
				this.$failTaskRepush(this.$route.query.tid, (res) => {
					// this.delDeviceNo = 0
					this.loading = 0
					if (res.status == 200) {
						this.$message.success(res.message)
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = 0
					// error
				})
			},
			delRow(row) {
				this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning',
					() => {
						// sure
						//console.log(row)
						var id = row.detailId
						this.loading = 1
						// '0'
						this.$pushDelTask(id, (res) => {
							// this.delDeviceNo = 0
							this.loading = 0
							if (res.status == 200) {
								this.getList()
							} else {
								this.$message.error(res.message)
							}
						}, () => {
							this.loading = 0
							// error
						})
					})
				// console.log(row)
			},
			bcDel() {
				var hit = 0
				this.multipleSelection.forEach((vl) => {
					if (vl.status == '1' ||
						vl.status == '1' ||
						vl.status == '6') {
						hit = 1
						return
					}
				})
				if (hit) {
					this.$message.error(this.$t('app_cantDelTask'))
				} else {
					var ids = ''
					this.multipleSelection.forEach((vl) => {
						ids += vl.detailId + ','
					})
					ids = ids.substring(0, ids.length - 1)
					if (!ids) {
						this.$message(this.$t('app_oneRecordMust'))
						return
					}
					this.loading = 1
					this.$pushDelTask(ids, (res) => {
						// this.delDeviceNo = 0
						this.loading = 0
						if (res.status == 200) {
							this.getList()
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						this.loading = 0
						// error
					})
				}
			},
			cCallback() {
				this.pObj = ''
				this.getList()
			},
			addPush() {
				var _this = this
				this.pObj = {
					type: 0, ///0task 1sysconfig
					taskId: this.$route.query.tid,
					taskType: this.tty,
					close: this.cCallback
				}
				console.log(this.pObj)
				this.stopTimer()
			},
			showBtn(tag, st) {
				// tag 0取消 1重推 2删除 3暂停 4继续
				// 1.等待中、下载中的时候，操作栏有“取消”按钮
				// 2.已取消的时候，操作栏有“重推”和“删除”按钮
				// 3.失败的时候，操作栏有“重推”和“删除”按钮
				// 4.成功的时候操作栏没有操作
				// 5.移除“暂停”操作

				// st ()
				// 新状态，modify by sing, 2017-06-17
				// st -1： 下载失败， -2： MD5校验失败， -3： 已经是最新版本，
				// -4： 文件格式不正确（不是apk文件）， -5： 更新失败，-6：用户取更，
				// 1： 下载中，返回下载进度，2： 下载完成， 3： 更新成功，6暂停 7取消
				var vl = st + '';
				// console.log('tag is ' + tag + ',status: ' + JSON.stringify(st));
				switch (vl) {
					case '1':
					case '2':
					case '4':
					case '0':
						if (st == 1 && tag == 3) {
							return true
						} else
							return tag == 0 ? true : false
					case '-6':
					case '7':
						// return tag == 1 || tag == 2? true:false
					case '-7':
					case '-4':
					case '-5':
					case '-8':
					case '-9':
					case '-10':
					case '-1':
					case '-2':
						return tag == 1 || tag == 2 ? true : false
					case '6':
						return tag == 4 ? true : false
				}
			},
			getProcess(mIds) {
				if (!mIds) {
					this.stopTimer()
					return
				}
				//console.log(this.$route.path)

				this.$missionPersent(mIds, (res) => {
					if (res.status == 200) {
						//console.log(res)
						var temp = []
						this.pInfo.forEach((vl, index) => {
							var newData = vl
							var data = res.data[index]
							if (data.result) {
								// taskStatus
								newData.value.progress = data.result.progress
								newData.value.status = data.result.status
								newData.value.taskStatus = data.result.status
								var st = data.result.status
								if (st != 1 && st != 2 && st != 4) {
									this.getList()
								}
							} else {
								this.getList()
							}
							temp.push(newData)
						})
						this.pInfo = temp
						// 把数据贴到缓存中

						this.pInfo.forEach((vl, index) => {
							this.tableData[vl.index] = vl.value
						})
						// 数据更新完成
						// console.log(res)
						// console.log(this.tableData)

					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
				})
			},
			processCore() {
				console.log('process check...')
				if (this.$route.path !== '/task/ptask/detail') {
					this.stopTimer()
					return
				}

				var arr = this.tableData
				this.pInfo = []
				this.tableData.forEach((vl, index) => {
					if (vl.taskStatus == '2' || vl.taskStatus == '1') { //upset 3
						this.pInfo.push({
							value: vl,
							index: index
						})
					}
				})
				var ids = ''
				this.pInfo.forEach((vl, index) => {
					ids += vl.value.detailId + ','
				})
				ids = ids.substring(0, ids.length - 1)
				this.getProcess(ids)
			},
			stopTimer() {
				clearInterval(window.pTm)
				clearTimeout(window.gTm)
				// clearTimeout(window.dTm)
				// window.dTm = ''
				window.pTm = ''
				window.gTm = ''
				//console.log(window.pTm, this.fTm)
			},
			updateTimer() {

				this.stopTimer()

				if (this.$route.path == '/task/ptask/detail') {
					//检查是否有整刷新数据
					var tg = false
					this.tableData.forEach(obj => {
						if (obj.taskStatus == '4' || obj.taskStatus == '-1') {
							tg = true
						}
					})
					if (tg) {
						var _this = this
						window.gTm = setTimeout(() => {
							if (_this.multipleSelection.length == 0) {
								_this.getList()
							}

						}, 6000)
						return
					}
					// -----
					// return
				} else {
					return
				}


				window.pTm = setInterval(() => {
					// console.log('tm go')
					this.processCore()
				}, 6000)
			},
			getList(isDialog) {
				if (this.$route.path != '/task/ptask/detail') {
					this.stopTimer()
					return
				}


				var tNameVl = this.queryKey ? this.queryKey : ''
				var statusVl = this.bindVl ? this.bindVl : ''
				var content = this.tContent ? this.tContent : ''
				// var orderType = this.tbOrder
				var taskId = this.$route.query.tid
				this.loading = 1
				var _this = this
				this.$pushTaskDetail(this.orderName, this.orderType, tNameVl, statusVl, this.page, this.$gRow, taskId, (
					res) => {
					this.loading = 0
					if (res.status == 200) {

						/////连带更新详情
						this.getDetail(isDialog, res.data.length == 0)

						this.tableData = res.data
						this.total = res.total


					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.loading = 0
				})
			},
			pageChange(vl) {
				this.page = vl
				this.getList()
			},
			bcbind() {
				var arr = []
				this.multipleSelection.forEach(item => {
					arr.push(item.terminalId)
				})

				this.bindRqs(arr.toString())
			},
			handleSelectionChange(val) {
				// this.sNum = val.length
				this.multipleSelection = val
				if (val.length == 0) {
					this.updateTimer()
				}
			},
			editCf() {
				this.$setWObj('dvconfigEdit', {
					type: 1,
					data: this.config,
					isSetLc: true
				})
				this.$router.push({
					path: '/dvconfig/detail/edit'
				})
			},
			showBindSt(row) {
				return this.bindSt[row.useStatus]
			},
			bindOp(row) {

				this.bindRqs(row.terminalId)
			},

			query() {
				this.getList()
			},
			srchDevice() {
				this.getDevices()
			},
			getDevices() {
				var vl = this.srchValue ? this.srchValue : ''
				var channel = this.mech1 ? this.mech1 : ''
				var status = this.status ? this.status : ''
				this.loading = 1
				this.$getDvDevices(this.index, this.$gRow, channel, vl, '', '', '', '', '', '', (res) => {
					console.log('dv', res)
					this.loading = 0
					if (res.data) {
						this.tableData = res.data
						this.total = res.total
					}
				}, () => {
					// error
					this.loading = 0
				})
			},
			addTer() {
				// this.dialogVisible=true
			},
			deleteApp(obj) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'),
					'warning', () => {
						console.log(obj)
						this.$delFstRecord(obj.detailId, (res) => {
							if (res.status == 200) {
								this.getList()
								this.$message.success(res.message)
							} else {
								this.$message.error(res.message)
							}
						}, '')
					}, '')
			},
			unbind(row) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'),
					'warning', () => {

						this.$tcDelDevice(row.detailId, (res) => {
							if (res.status == 200) {
								this.getList()
								this.$message.success(res.message)
							} else {
								this.$message.error(res.message)
							}
						}, '')
					}, '')
			},
			editApp(row) {
				this.$setWObj('filestEdit', {
					type: 1,
					data: row
				})
				this.$router.push({
					path: '/stfile/detail/edit'
				})
			},
			pushApp(row) {
				this.$setWObj('pushList', {
					type: '13',
					data: row
				})
				this.$router.push({
					path: '/stfile/detail/push'
				})

			},
			getStatistics() {
				this.loading = 1
				this.$pTaskStatistics(this.$route.query.tid, res => {
					this.loading = 0
					if (res.status == 200) {
						this.items[0].num = res.data.terminalNum
						this.items[1].num = res.data.successNum
						this.items[2].num = res.data.waitNum
						this.items[3].num = res.data.downloadNum
						this.items[4].num = res.data.failNum
						this.items[5].num = res.data.cancelNum
					} else {
						this.$message(res.message)
					}
				}, () => {
					this.loading = 0
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			getDetail(isDialog, islsnull) {
				// this.loading = 0


				var param = this.$route.query
				this.$pTaskProgress(param.tid, res => {
					// this.loading = 0
					if (res.status == 200) {

						var obj = res.data
						///// init pop data
						// var tmparr = []
						// var tmparrp = []
						obj.subTask.forEach(item => {
							switch (item.taskType) {
								case '1':
								case '2':
								case '5':
									if (item.installType == 0) {
										item.pop = [this.$t('app_tipud')]
									} else {
										item.pop = [this.$t('app_forceins')]
									}
									break
								case '7':
									var tmparr = []
									var tmparrp = []
									tmparr = item.installType.split('-')
									tmparr.forEach((sitem, index) => {
										switch (index) {
											case 0:
												if (sitem == 0) {
													tmparrp.push(this.$t('app_tipud'))
												} else {
													tmparrp.push(this.$t('app_forceins'))
												}
												break
											case 1:
												if (sitem == 0) {
													tmparrp.push(this.$t('app_insafnorun'))
												} else {
													tmparrp.push(this.$t('app_autorun'))
												}
												break
											case 2:
												if (sitem == 0) {
													tmparrp.push(this.$t('app_normalins'))
												} else {
													tmparrp.push(this.$t('app_cusins'))
												}
												break
										}
									})
									item.pop = tmparrp
									break
								case '9':
									if (item.content == 'XZYY') {
										// var type = item.installType.split('-')
										// 详情显示bug
										if (item.installType == 2) {
											item.pop = [this.$t('app_normalunins')]
										} else {
											item.pop = [this.$t('app_appuninstall')]
										}
									} else if (item.content == 'HFCCSZ') {
										if (item.installType == 4) {
											item.pop = [this.$t('appp_tipoperate')]
										} else {
											item.pop = [this.$t('app_forcerun')]
										}
									}
									break
								default:
									break
							}
						})
						// console.log('final obj', obj)
						this.info = obj

						var count = res.data.count
						this.items[0].num = count.terminalNum
						this.items[1].num = count.successNum
						this.items[2].num = count.waitNum
						this.items[3].num = count.downloadNum
						this.items[4].num = count.failNum
						this.items[5].num = count.cancelNum

						var subtask = res.data.subTask
						if (subtask.length > 0) {
							var obj = subtask[0]
							this.tty = obj.taskType
						}
						var isRunDia = false
						//弹窗代码
						if (this.$route.query.showdv && isDialog && islsnull) {

							this.pObj = {
								type: 0, /////0task 1sysconfig
								taskId: this.$route.query.tid,
								taskType: this.tty,
								close: this.cCallback
							}
							isRunDia = true
						}
						if (!isRunDia) {
							this.updateTimer()
						}


					} else {
						this.$message(res.message)
					}
				}, () => {
					// this.loading = 0
					this.$message.error(this.$t('app_rqsError'))
				})
			},

			getStatus(value) {
				if (!value) return ''
				switch (value) {
					case '0':
						return {
							vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'
						}
					case '1':
						return {
							vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'
						}
					case '2':
						return {
							vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'
						}
					case '3':
						return {
							vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'
						}
				}
			},

			setInstallType(type) {
				return this.$installType[type]
			},
			dateFormat(row, column) {
				var date = row[column.property]
				if (date == undefined) {
					return ''
				}
				return mm(date).format('YYYY-MM-DD hh:mm:ss')
			},
			selectChange(vl) {
				// this.getDevices()
				this.getList()
			},
			pageSelect(index) {
				this.index = index
				this.getDevices()
			},
			pageSize(val) {
				this.$gRow = val
				this.getList()
			},



			delHis(row) {

				this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
					confirmButtonText: this.$t('app_sure'),
					cancelButtonText: this.$t('app_cancel'),
					type: 'warning'
				}).then(() => {
					this.loading = 1
					this.$delLauncherHistory(row.versionid, (res) => {
						this.loading = 0
						if (res.status == 200) {
							this.getHistory()
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.loading = 0
					})

				}).catch(() => {})

			},

			imgFullUrl(path) {
				if (path) {
					// return this.$host + path
					// console.log('imgpath', path, this.$urls.prefix + path)
					return this.$urls.prefix + path
					//return path
				} else {
					return ''
				}
			},

			getHistory() {
				if (this.config.status !== '2') {
					return
				}
				this.loading = 1
				this.$launcherHistory(this.config.launcherid, (res) => {
					console.log('his', res)
					this.loading = 0
					if (res.status == 200) {
						this.tableData = res.data
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.loading = 0
				})

			},
			uploadNew() {
				// this.$t('menu.sysManageSub.launchNewVer')
				var obj = {
					type: 2,
					data: this.config
				}
				var key = 'launcherEdit'
				this.$setWObj(key, obj)
				this.$router.push({
					path: '/launch-newver'
				})
			},
			init() {
				// this.config = this.$getWObj().dvconfigDetail
				// if (this.config.appPackage) {
				//   this.tags = this.config.appPackage.split(',')
				// }
				// console.log('cc', this.config)
				// this.getHistory()
				this.getList()
				this.getDevices()
			}

		},
		mounted() {

			var _this = this
			this.tqobj = {
				keys: ['taskType', 'ftype', 'sftype', 'comm'],
				callback: (data) => {
					this.taskType = data[0]
					this.getftype = data[1]
					this.getstype = data[2]
					this.comm = data[3]
				}
			}

			this.tid = this.$route.query.tid



			this.getList(true)
		}
	}
</script>


// WEBPACK FOOTER //
// detail.vue?14dec544